import React, { useState, useEffect } from 'react';
import { Table, Button, Icon, Modal, Header, Message, Toast, Image } from 'react-frontier';
import { Dropdown } from 'semantic-ui-react';
import { AddAssetModal, AssetViewModal, InfoLog } from './index';
import { Asset, AssetType, SetLoading } from '../SiteClasses';
import { bindClick, bindClose } from '../SiteUtil';
import { useUser } from '../hooks';
import UserAccess from '../UserAccess';
import API, { CDN_URL } from '../API';
import moment from 'moment';

interface EvidenceTableProps{
	dateId: number;
}

enum Modals{
	ADD_ASSET = 1,
	VIEW_ASSET = 2,
	DELETE_ASSET = 3,
	INFO_LOG = 4
}

var EvidenceTable = (props: EvidenceTableProps)=>{
	var { hasAccess } = useUser();
	var [assets, setAssets] = useState<Asset[]>(null);
	var [selectedAsset, setSelectedAsset] = useState<Asset>(null);
	var [shownModal, setShownModal] = useState<Modals>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);

	useEffect(()=>{
		getAssets();
	}, [props.dateId]);

	var getAssets = async ()=>{
		API.getEventAssets(props.dateId).then(res=>{
			if(res.error) return Toast.error(res.message);
			setAssets(res.data);
		}).catch(err=>{
			Toast.error('Hubo un error cargando las evidencias (LCL-1)');
		})
	}

	var onAssetCreated = (newAsset: Asset)=>{
		setAssets(prev => [...prev, newAsset]);
		setShownModal(null);
	}

	var onDeleteAsset = (asset: Asset)=>{
		setSelectedAsset(asset);
		setShownModal(Modals.DELETE_ASSET);
	}

	var onInfoLog = (asset: Asset)=>{
		setSelectedAsset(asset);
		setShownModal(Modals.INFO_LOG);
	}

	var onAssetDeleted = (asset_id: number)=>{
		setAssets(prev => prev.filter(asset => asset.asset_id !== asset_id));
	}

	var deleteAsset = (setLoading: SetLoading)=>{
		if(!selectedAsset) return;
		setLoading(true);
		API.deleteAsset(selectedAsset.asset_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Evidencia eliminada correctamente');
			onAssetDeleted(selectedAsset.asset_id);
			setShownModal(null);
			setSelectedAsset(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado eliminando la evidencia (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	var viewAsset = (a: Asset)=>{
		return ()=>{
			setSelectedAsset(a);
			setShownModal(Modals.VIEW_ASSET);
		}
	}

	return <div className="ar evidence-list-screen">
		<div>
			{!assets ? (
				<Header centered loading text='Cargando datos...' />
			) : assets ? (
				<div className='evidences'>
					<div className='evidence create' onClick={bindClick(setShownModal, Modals.ADD_ASSET)}>
						<Icon name="plus" />
						<div className='text'>Agregar evidencia</div>
					</div>
					{assets.map(asset=>(
						<div key={`AST-${asset.asset_id}`} className='evidence' onClick={viewAsset(asset)}>
							<div className='preview'>
								<Image src={asset.url} className='image' fallback='/placeholder.png' />
								<div className='badge'>
									{asset.type_id===AssetType.PDF ? 'PDF' : asset.type_id===AssetType.VIDEO ? 'VID' : 'IMG'}
								</div>
							</div>
							<div className='info'>
								<div className='name' title={asset.asset_name}>{asset.asset_name}</div>
								<div className='creator'>{asset.user_creator_name}</div>
								<div className='date'>{moment.unix(asset.date_created).format('DD/MMM/YY HH:mm')}</div>
							</div>	
							<div className='actions' onClick={e=>{
								e.preventDefault();
							}}>
								<Dropdown icon={<Icon name='ellipsis-v'/>} className='icon' pointing='top left'>
									<Dropdown.Menu>
										<Dropdown.Item onClick={()=> onInfoLog(asset)}>
											Ver Logs 
										</Dropdown.Item>
										{hasAccess(UserAccess.EVENTS.EDIT_EVENTS) && (
											<Dropdown.Item onClick={()=> onDeleteAsset(asset)}>
												Eliminar 
											</Dropdown.Item>
										)}
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					))}
				</div>
			) : (
				<div className='empty'>
					<Icon name='folder-open' size={3} />
					<div>No se encontraron evidencias</div>
				</div>
			)}
		</div>
		<AddAssetModal open={shownModal === Modals.ADD_ASSET} onClose={bindClose(setShownModal)} onAdded={onAssetCreated} dateId={props.dateId} />
		<AssetViewModal open={shownModal === Modals.VIEW_ASSET} onClose={bindClose(setShownModal)} asset={selectedAsset} onDeleted={(a)=>onAssetDeleted(a)} />
		<Modal open={shownModal === Modals.DELETE_ASSET} onClose={bindClose(setShownModal)} size='tiny'>
			<Modal.Header>Eliminar evidencia</Modal.Header>
			<Modal.Content>
				<Header text='¿Eliminar evidencia?' subtext='Esta acción no se puede deshacer' />
				{selectedAsset && (
					<Table
						details
						titleSize='small'
						title='Detalles'
						data={[
							['ID', selectedAsset.asset_id],
							['Nombre', selectedAsset.asset_name],
							['Tipo', 'Documento'],
							['Creado', moment.unix(selectedAsset.date_created).format('DD/MMM/YY HH:mm')],
							['Creador', selectedAsset.user_creator_name],
						]}
					/>
				)}
				<Message type='error' list={modalPrompts} />
			</Modal.Content>
			<Modal.Actions>
				<Button basic text='Cancelar' onClick={bindClose(setShownModal)} />
				<Button text='Eliminar' color='red' onClick={deleteAsset} />
			</Modal.Actions>
		</Modal>
		<InfoLog open={shownModal === Modals.INFO_LOG} onClose={bindClose(setShownModal)} data={selectedAsset} title="Historial de la Evidencia" />
	</div>
}

export default EvidenceTable;